// extracted by mini-css-extract-plugin
export default {"title":"CTABannerSingle_title__vDhNA","alignedCenter":"CTABannerSingle_alignedCenter__9-mCl"};